module.exports = require("@splunk/react-ui/WaitSpinner");